// extracted by mini-css-extract-plugin
export default {"chart":"Chart_chart__AE7Qb","chart_title":"Chart_chart_title__-FN-f","chart_time":"Chart_chart_time__cgYLH","chart_c":"Chart_chart_c__1fTbC"};